import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPut } from './utils'

export const getProgressiveFormDate = (id, date) => {
  // http://103.91.191.229:9000/api/subproject/{projectVersionId}/progress/{progressDate}
  const url = `${API_ROOT}/subproject/${id}/progress/${date}`
  return doGet(url)
}

export const saveProgressiveSubProjec = (id, request) => {
  // http://103.91.191.229:9000/api/subproject/{projectVersionId}/progress
  const url = `${API_ROOT}/subproject/${id}/progress`
  return doPost(url, request)
}
